import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ReadOnlyBannerProps {
  onUpgrade: () => void;
}

/**
 * Full-width banner shown when the user is in read_only tier (trial/subscription
 * expired and free quota exhausted). Replaces the generate CTA and makes the
 * access restriction immediately visible.
 */
export function ReadOnlyBanner({ onUpgrade }: ReadOnlyBannerProps) {
  return (
    <div className="flex items-start gap-3 border border-destructive/20 bg-destructive/5 px-5 py-4">
      <Lock className="mt-0.5 size-4 shrink-0 text-destructive" />
      <div className="flex-1">
        <p className="text-[13px] font-medium text-destructive">
          Mode consultation
        </p>
        <p className="mt-0.5 text-[12px] leading-relaxed text-ink-70">
          Votre accès a expiré. Consultez votre historique ou réabonnez-vous
          pour générer un nouveau menu.
        </p>
      </div>
      <Button
        size="sm"
        variant="destructive"
        className="shrink-0 text-[12px]"
        onClick={onUpgrade}
      >
        Réactiver
      </Button>
    </div>
  );
}
